// extracted by css-extract-rspack-plugin
export default {"errorContainer":"ErrorView_errorContainer__Kmse-","errorMessage":"ErrorView_errorMessage__URPXy"};